<template>
  <div>
    <LoginStudioForm v-if="!signup" @signup="signup=true"/>
    <SignupStudio v-if="signup" @login="signup=false"/>
  </div>
</template>

<script>
import LoginStudioForm from '@/components/Login-Studio.vue';
import SignupStudio from '@/components/Signup-Studio.vue';

export default {
  name: "LoginStudio",
  data () {
    return {
      signup: false,
    }
  },
  components: {
    LoginStudioForm,
    SignupStudio
  },
  methods: {
    submit: function(evt){
      evt.preventDefault()
      this.$axios.post( this.$apibase + '/auth/obtain_token/', {        
          'username': this.username,
          'password': this.password
      })
      .then(
        (response) => {
          localStorage.setItem('access_token', response.data.token);
          this.$router.push('/dashboard-lab');
        }
      )
      .catch(()=>{
        this.$store.dispatch('setAlert', {message: "La combinazione di username e password è incorretta.", type: 'danger'});
      })
    }
  }
};
</script>

<style scoped>
  .container {
    text-align: center;
    padding-top: 100px;
  }
  .card{    
    width: 400px;
    display: inline-flex;
    height: 390px;
    box-shadow: 0 0 5px #6abf61;
    padding: 80px 50px;
    text-align: center;
    align-items: center;    
  }
  .card-title{
    font-size: 21px;
    font-weight: bold;
    float: left;
    padding-left: 10px;
  }
  .card-img{
    width:30px;
    float: left;
  }
  .input{
    padding-top: 40px;
    width: 100%;
  }
  .button {
    padding-top: 20px;
    width: 100%;
  }
  .signup{
    padding-top:20px;
    font-size: small;
  }
</style>